import { WmsProxy } from '../WmsProxy.js';

export { LeafletWmsProxy };

class LeafletWmsProxy extends WmsProxy {

    constructor(options) {
        super();

        const layer = L.tileLayer.wms(options.url, {
            layers: options.layers,
            version: options.version,
            attribution: options.attribution,
            maxZoom: 30,
            format: 'image/png',
            transparent: true,
        });

        layer.on("loading", (e) => this.fire("loading", e));
        layer.on("load", (e) => this.fire("load", e));

        this.leafletLayer = layer;
        this.leafletMap = null;
    }

    reload() {
        this.leafletLayer.redraw();
    }

    setZIndex(zIndex) {
        this.leafletLayer.setZIndex(zIndex);
    }

    setOpacity(opacity) {
        this.leafletLayer.setOpacity(opacity);
    }

    setParams(params) {
        const changed = super.setParams(params);

        for (let key in changed) {
            if ((changed[key] === null) && (key in this.leafletLayer.wmsParams)) {
                delete this.leafletLayer.wmsParams[key];
            } else {
                this.leafletLayer.wmsParams[key] = changed[key];
            }
        }
    }

    setProjection(crs) {
        const code = crs.replace(":", "");
        if (code in L.CRS) {
            this.leafletLayer.options.crs = L.CRS[code];
            this.leafletLayer.wmsParams.crs = L.CRS[code];
        }
    }

    setLayers(layers) {
        this.leafletLayer.options.layers = layers;
    }

    addToMap(leafletMap) {
        this.leafletMap = leafletMap;
        this.leafletLayer.addTo(leafletMap);
    }

    removeFromMap() {
        this.leafletLayer.remove();
        this.leafletMap = null;
    }

}